import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const ProductListContainer = styled.div``;

export const ProductListItem = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
    color: ${({ isVariation }) => (isVariation ? '#808080' : `${styles.colors.GRAY_DARKER}`)};
    font-size: ${({ isVariation }) => (isVariation ? '11px' : `${styles.fontSizes.SIZE_6}`)};
    font-weight: ${styles.fontWeights.SEMIBOLD};
    font-style: normal; 
`;

export const Title = styled.div`
  color: ${({ color }) => color} !important;
  text-align: left;
`;

export const vl = styled.div`
  border-left: 1px solid ${styles.colors.GRAY_LIGHT_2};
  margin-left: 40px;
`;

export const Quantity = styled.div`
  flex-shrink: 0;
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_5,
    styles.fontWeights.SEMIBOLD
  )}
  margin-right: 10px;
  min-width: 20px;
`;

export const Name = styled.div`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_6, styles.fontWeights.NORMAL)}
  width: 100%;
`;

export const Price = styled.div`
  text-align: left;
  color: ${({ price, isVariation, isProduct, isSubtotal, isTotal }) =>
    (price > 0 && isVariation) || isProduct || isSubtotal || isTotal
      ? `${styles.colors.GRAY_DARKER}`
      : '#808080'};
  font-size: ${({ fontSize }) => fontSize || '14px'};
  font-weight: ${({ isSubtotal }) => (isSubtotal ? '600' : '')};
  padding-left: ${({ isDiscount, isSubtotal }) => (isDiscount || !isSubtotal ? '0' : '8px')};
`;

export const TotalPrice = styled.div`
  ${({ big }) =>
    mixins.fontStyle(
      styles.colors.MAIN_COLOR,
      big ? styles.fontSizes.SIZE_4 : styles.fontSizes.SIZE_5,
      styles.fontWeights.SEMIBOLD
    )}
`;

export const LeftColumn = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  width: 100%;
`;

export const MiddleColumn = styled.div`
  flex-shrink: 0;
  margin-left: 40px;
  min-width: 135px;
  text-align: right;
`;

export const RightColumn = styled.div`
  flex-shrink: 0;
  min-width: 100px;
`;

export const SubtotalContainer = styled.div`
  border-top: 1px solid ${styles.colors.GRAY_LIGHT_2};
  margin-top: 15px;
  padding: 10px 0;
`;

export const SubtotalItem = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'flex-end' })}
  line-height: 30px;
`;

export const TotalContainer = styled(SubtotalContainer)`
  margin-top: 0;
  padding-bottom: 0;
  padding-top: 15px;
`;

export const TotalItem = styled(SubtotalItem)``;

export const HeaderContent = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'flex-end' })}
`;

export const Comment = styled.p`
  color: #808080 !important;
  font-style: normal;
  font-weight: normal;
  font-size: ${styles.fontSizes.SIZE_7};
  line-height: 20px;

  padding-left: 29px;
`;

export const SubItem = styled.p`
  padding-left: ${({ paddingLeft }) => paddingLeft};
  line-height: 20px;
`;

export const ProductListItemContainer = styled.div``;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/BoxProduct/style.js